import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PwaConfirmComponent } from './dialogs/pwa-confirm/pwa-confirm.component';
import { TooltipDirective } from './directives/tooltip.directive';
import { SnackbarComponent } from './components/snackbar/snackbar.component';
import { MaterialModule } from './material/material.module';
import { RemoveFromObjectPipe } from './pipes/remove-from-object.pipe';
import { SliderComponent } from './components/slider/slider.component';

const COMPONENTS = [
    SnackbarComponent,
    PwaConfirmComponent,
    SliderComponent
];

const MODULES = [
    FormsModule,
    CommonModule,
    MaterialModule,
    ReactiveFormsModule,
    RouterModule
];

const PIPES = [
    RemoveFromObjectPipe
];

const DIRECTIVES = [
    TooltipDirective
];

@NgModule({
    declarations: [...COMPONENTS, ...DIRECTIVES, ...PIPES],
    imports: [...MODULES],
    exports: [...COMPONENTS, ...MODULES, ...DIRECTIVES, ...PIPES]
})
export class SharedModule { }
